import React, { useEffect, useState, useMemo } from 'react';
import axios from 'axios';
import { API_URL, ENDPOINTS } from '../constants/api';
import { decodeToken, getToken } from '../utils/TokenUtils';
import ModalForm from './ModalForm';
import Swal from 'sweetalert2';


function CustomerCareDashboard() {
  const token = getToken();
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [sortColumn, setSortColumn] = useState(null);
  const [sortDirection, setSortDirection] = useState('asc');
  const [data, setData] = useState([]);
  const [activeTab, setActiveTab] = useState('Pending');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentRoute, setCurrentRoute] = useState('New-Problem-Process');
  const [selectedId, setSelectedId] = useState(null);
  const [StatusOptions,setStatusOptions]=useState([])
   const userType = decodeToken(token,'userLevel');
 const allowedUserTypesforChangeButton = ['customer_care', 'Developer', 'head_developer', 'eng_customer_care', 'eng_developmemt'];
 const [IsOpenNewProblemModel, setIsOpenNewProblemModel] = useState(false);
 const [nPRoute,setNpRoute]=useState('New-Problem');

  const openModal2 = (route) => {
    setCurrentRoute(route);
    setIsModalOpen(true);
  };

  const closeModal = () => setIsModalOpen(false);

   const openModal3 = (route) => {
    setNpRoute(route);
    setIsOpenNewProblemModel(true);
  };
  const closeModal2 = () => setIsOpenNewProblemModel(false);

  const user_id = decodeToken(token, 'id');

  const tabs = [
    'Pending', 'Assigned', 'Returned', 'Process', 'Stopped',
    'Done', 'Complete', 'InComplete', 'Cancel'
  ];

  const fetchProblems = async (status) => {
    setLoading(true);
    setError(null);
    const body = { status, user_id };
    try {
      const response = await axios.post(
        `${API_URL}/${ENDPOINTS.SYS}/reportCustom/getProblemlists`,
        body,
        { headers: { Authorization: token ? `Bearer ${token}` : '' } }
      );
      setData(response.data?.data || []);
      console.log('res from getproble',response.data)
    } catch (err) {
      setError('Failed to load data');
      setData([]);
    } finally {
      setLoading(false);
    }
      console.log('data',data);
  };

  useEffect(() => {
    fetchProblems(activeTab);
  
  }, [activeTab]);

  const handleSort = (column) => {
    if (column === sortColumn) {
      setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
    } else {
      setSortColumn(column);
      setSortDirection('asc');
    }
    setCurrentPage(1);
  };

  const filteredData = useMemo(() => {
    let filtered = [...data];
    if (searchTerm) {
      filtered = filtered.filter(item =>
        Object.values(item).some(value =>
          value?.toString().toLowerCase().includes(searchTerm.toLowerCase())
        )
      );
    }
    if (sortColumn) {
      filtered.sort((a, b) => {
        const valA = a[sortColumn];
        const valB = b[sortColumn];
        if (typeof valA === 'string' && typeof valB === 'string') {
          return sortDirection === 'asc' ? valA.localeCompare(valB) : valB.localeCompare(valA);
        }
        return sortDirection === 'asc' ? valA - valB : valB - valA;
      });
    }
    return filtered;
  }, [data, searchTerm, sortColumn, sortDirection]);

  const totalItems = filteredData.length;
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);

  const renderSortArrow = (column) => {
    if (column !== sortColumn) return null;
    return sortDirection === 'asc' ? ' ▲' : ' ▼';
  };

useEffect(() => {
  const defaultOptions = {
    Assigned: ['Pending', 'Process'],
    Pending: ['Assigned', 'Cancel'],
    Process: ['Done', 'Stopped', 'Pending'],
    Returned: ['Assigned'],
    Stopped: ['Process', 'Cancel'], 
    Done: ['Complete', 'InComplete'],
    Complete: ['Pending'],
    InComplete: ['Assigned','Pending'],
    Cancel: [],
  };

  let options = defaultOptions[activeTab] || [];

  // Customize options by userType
  if (['Developer', 'admin'].includes(userType)) {
    setStatusOptions(options);
  } else if (['customer_care', 'head_developer'].includes(userType)) {
    const careOptions = {
      Pending: ['Cancel','Assigned','Stopped'],
      Assigned: ['Pending'],
      Process: ['Pending', 'Stopped'],
      Stopped: ['Cancel','Process'],
      Returned: [''],
      Done: [],
      InComplete:['Pending'],
      Complete:['Pending'],
      Cancel:[]
    };
    setStatusOptions(careOptions[activeTab] || []);
  } else if (['eng_customer_care', 'eng_development'].includes(userType)) {
    const engOptions = {
      Pending: ['Assigned'],
      Assigned: ['Pending', 'Process'],
      Process: ['Pending','Done'],
      Stopped: [''],
      Returned: [''],
      Done: [],
      InComplete:['Assigned'],
      Complete:[],
      Cancel:[]
    };
    setStatusOptions(engOptions[activeTab] || []);
  } else {
    setStatusOptions([]);
  }
  }, [activeTab, userType]);



  return (
    <div className="m-6 p-3 bg-gradient-to-br from-green-50 to-green-100 min-h-screen font-sans">
      <div className="bg-white rounded-3xl shadow-xl pl-5 mb-5">
        <h1 className="text-4xl font-extrabold text-green-700 mb-6 text-center tracking-wide">
           Welcome To Customer Care 
        </h1>

        {/* Tabs */}
        <div className="flex flex-wrap justify-center mb-6 gap-4 mx-6 ">
          {tabs.map((tab) => (
            <button
              key={tab}
              onClick={() => setActiveTab(tab)}
              className={`mx-1 rounded-full px-9 py-3 text-base font-semibold min-w-[120px] transition-all duration-300 ease-in-out
                ${activeTab === tab
                  ? 'bg-green-600 text-white shadow-md scale-105'
                  : 'bg-green-100 text-green-700 hover:bg-green-200'
                }`}
            >
              {tab}
            </button>
          ))}
        </div>

        {/* Search and Page Size */}
        <div className="flex flex-col md:flex-row gap-y-4 md:gap-x-6 mb-4 mt-4">
          <input
            type="text"
            placeholder="🔍 Search here..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="flex-1 p-3 border border-green-300 rounded-full focus:outline-none focus:ring-2 focus:ring-green-400 text-gray-700 placeholder-gray-400"
          />
          <select
            value={itemsPerPage}
            onChange={(e) => setItemsPerPage(Number(e.target.value))}
            className="p-3 border border-green-300 rounded-full focus:outline-none focus:ring-2 focus:ring-green-400 text-gray-700"
          >
            {[5, 10, 20, 50].map((size) => (
              <option key={size} value={size}>{size} / page</option>
            ))}
          </select>
             {
  (userType === 'Developer' || userType === 'customer_care') && (
    <button 
      onClick={() => openModal3('New_Problem')}
      className='btn btn-primary p-3 m-5'
    >
      New Problem
    </button>
  )
}

        </div>
      </div>

      {/* Table */}
      {loading ? (
        <div className="text-center py-10 text-green-600 text-2xl font-semibold">Loading... 🍃</div>
      ) : error ? (
        <div className="text-center py-10 text-red-500 text-xl font-semibold">
          Oops! Something went wrong: {error}
        </div>
      ) : (
        <div className="bg-white rounded-3xl shadow-xl p-4 overflow-auto mb-10">
          {currentItems.length > 0 ? (
            <div className="overflow-x-auto">
              <table className="min-w-full table-auto border border-green-300 text-sm">
                <thead className="bg-green-100">
                  <tr>
                    <th className="px-3 py-2 text-green-800 font-bold border border-green-300">Action</th>
                    {data[0] && Object.keys(data[0]).map((key) => (
                      <th
                        key={key}
                        className="px-3 py-2 text-left text-green-800 font-bold border border-green-300 cursor-pointer hover:bg-green-200"
                        onClick={() => handleSort(key)}
                      >
                        {key.replace(/([A-Z])/g, ' $1').trim()}
                        {renderSortArrow(key)}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {currentItems.map((item, index) => (
                    <tr key={index} className="hover:bg-green-50">
                      <td className="px-2 py-2 text-center border border-green-200">
                        {allowedUserTypesforChangeButton.includes(userType) &&(
                            <button
                          className="bg-green-600 text-white px-5 py-2 rounded-full text-sm hover:bg-green-700 transition-all"
                             onClick={(e) => {
  if (!StatusOptions || StatusOptions.length === 0) {
    Swal.fire({
      icon: 'warning',
      title: 'No Status Options',
      text: `You Don't Have Permission To Change Status In ${activeTab} Tab.`,
      confirmButtonColor: '#22c55e', // Tailwind green-500
    });
  } else {
    const idCell = e.currentTarget.closest('tr')?.children[1];
    if (idCell) {
      const id = idCell.textContent.trim();
      setSelectedId(id);
      console.log("Selected ID:", id);
    }
    openModal2('New_Problem_Process');
  }
}}

                        >
                          Change Status
                        </button>
                        )}
                      </td>
                      {Object.entries(item).map(([key, val], i) => (
                        <td
                          key={i}
                          className={`px-2 py-2 border border-green-200 text-gray-800 ${
                            key.toLowerCase() === 'description'
                              ? 'whitespace-pre-wrap break-words max-w-xs'
                              : key.toLowerCase() === 'id'
                                ? 'font-bold text-sm text-green-800'
                                : 'whitespace-nowrap max-w-[150px] overflow-hidden text-ellipsis'
                          }`}
                        >
                          {val}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <div className="text-center py-8 text-gray-600 text-lg font-medium">
              No data found 🍃
            </div>
          )}

          {/* Pagination */}
          {totalItems > itemsPerPage && (
            <div className="flex justify-center mt-5 space-x-3">
              <button
                onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                disabled={currentPage === 1}
                className="px-4 py-2 bg-green-400 text-white rounded-full hover:bg-green-500 disabled:opacity-50"
              >
                Previous
              </button>
              <span className="px-4 py-2 text-green-800 font-semibold">
                Page {currentPage} of {Math.ceil(totalItems / itemsPerPage)}
              </span>
              <button
                onClick={() =>
                  setCurrentPage(prev =>
                    Math.min(prev + 1, Math.ceil(totalItems / itemsPerPage))
                  )
                }
                disabled={currentPage === Math.ceil(totalItems / itemsPerPage)}
                className="px-4 py-2 bg-green-400 text-white rounded-full hover:bg-green-500 disabled:opacity-50"
              >
                Next
              </button>
            </div>
          )}
        </div>
      )}

      {/* Modal */}
      {isModalOpen && currentRoute && (
        <ModalForm
         
          userId={user_id}
          token={token}
          route={currentRoute}
          isOpen={isModalOpen}
          onRequestClose={closeModal}
        />
      )}

      {IsOpenNewProblemModel && nPRoute && (
        <ModalForm
        
          userId={user_id}
          token={token}
          route={nPRoute}
          isOpen={IsOpenNewProblemModel}
          onRequestClose={closeModal2}
        />
      )}
    </div>
  );
 
}

export default CustomerCareDashboard;
